var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FormControl } from '@mui/material';
import { useCallback } from 'react';
import { useBackgroundStore } from '../store/background';
import { backgroundImages } from '../types/Images';
import { UISelect } from './inputs/UISelect';
export var BackgroundSelector = function () {
    var backgroundOptions = Object.values(backgroundImages).map(function (backgroundImage) { return ({
        label: backgroundImage,
        value: backgroundImage,
    }); });
    var setActiveBackground = useBackgroundStore(function (state) { return state.updateBackground; });
    var handleBackgroundChange = useCallback(function (newValue) {
        if (newValue) {
            setActiveBackground(newValue.value);
        }
    }, [setActiveBackground]);
    var activeBackground = useBackgroundStore(function (state) { return state.background; });
    var selectedBackground = activeBackground
        ? {
            label: activeBackground,
            value: activeBackground,
        }
        : null;
    return (_jsx(_Fragment, { children: _jsx(FormControl, __assign({ sx: {
                display: 'flex',
                flexDirection: 'row',
                gap: 1,
            }, size: "small" }, { children: _jsx(UISelect, { sx: { width: '250px' }, options: backgroundOptions, value: selectedBackground, onChange: handleBackgroundChange, label: "Select a preview background", multiple: false }) })) }));
};
